import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/api'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token') || null)
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'))
  const tokenExpiry = ref(localStorage.getItem('tokenExpiry') || null)
  let sessionCheckInterval = null

  const isAuthenticated = computed(() => {
    if (!token.value) return false
    // Check if token is expired
    if (tokenExpiry.value && Date.now() > parseInt(tokenExpiry.value)) {
      return false
    }
    return true
  })

  // Parse JWT to get expiry time
  function parseJwt(token) {
    try {
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
      return JSON.parse(jsonPayload)
    } catch (e) {
      return null
    }
  }

  // Start session check interval
  function startSessionCheck() {
    if (sessionCheckInterval) clearInterval(sessionCheckInterval)
    
    // Check every minute
    sessionCheckInterval = setInterval(() => {
      if (tokenExpiry.value && Date.now() > parseInt(tokenExpiry.value)) {
        logout()
        // Only redirect to login if currently on admin pages
        if (window.location.pathname.startsWith('/ntspra')) {
          window.location.href = '/ntspra/login?expired=1'
        }
      }
    }, 60000) // 1 minute
  }

  // Stop session check
  function stopSessionCheck() {
    if (sessionCheckInterval) {
      clearInterval(sessionCheckInterval)
      sessionCheckInterval = null
    }
  }

  async function login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials)
      token.value = response.data.token
      user.value = response.data.user
      
      // Parse token to get expiry
      const payload = parseJwt(response.data.token)
      if (payload && payload.exp) {
        tokenExpiry.value = (payload.exp * 1000).toString() // Convert to milliseconds
        localStorage.setItem('tokenExpiry', tokenExpiry.value)
      }
      
      localStorage.setItem('token', token.value)
      localStorage.setItem('user', JSON.stringify(user.value))
      
      // Start session monitoring
      startSessionCheck()
      
      return response.data
    } catch (error) {
      throw error
    }
  }

  function logout() {
    token.value = null
    user.value = null
    tokenExpiry.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('tokenExpiry')
    stopSessionCheck()
  }

  // Check token validity on store init
  function initAuth() {
    if (token.value && tokenExpiry.value) {
      if (Date.now() > parseInt(tokenExpiry.value)) {
        logout()
      } else {
        startSessionCheck()
      }
    }
  }

  // Initialize on store creation
  initAuth()

  return {
    token,
    user,
    tokenExpiry,
    isAuthenticated,
    login,
    logout,
    initAuth
  }
})










